import { DEFAULT_HTTP_TIMEOUT } from 'src/app/interceptors/timeout.interceptor';

// A gap this long with no request lets a flow that chains requests (sign-up) reach its next one or its navigation.
export const IDLE_SETTLE_MS = 500;
// Every request has finished or timed out by then; past it, whatever is still open is not worth waiting for.
export const IDLE_MAX_WAIT_MS = DEFAULT_HTTP_TIMEOUT;
const IDLE_CHECK_MS = 100;

export interface RequestsInFlight {
  /** Counts a request as in flight; call the returned function once when it settles. */
  start(): () => void;
  isIdle(): boolean;
}

export function createRequestsInFlight(now: () => number): RequestsInFlight {
  let count = 0;
  let lastChangeAt = Number.NEGATIVE_INFINITY;
  return {
    start() {
      count++;
      lastChangeAt = now();
      let settled = false;
      return () => {
        if (settled) {
          return;
        }
        settled = true;
        count--;
        lastChangeAt = now();
      };
    },
    isIdle() {
      return count === 0 && now() - lastChangeAt >= IDLE_SETTLE_MS;
    },
  };
}

export const requestsInFlight = createRequestsInFlight(() => Date.now());

/** Runs the callback once no API request has been in flight for a moment, or after IDLE_MAX_WAIT_MS at the latest. */
export function whenNoRequestsInFlight(callback: () => void, requests: RequestsInFlight = requestsInFlight): void {
  const startedAt = Date.now();
  const check = () => {
    if (requests.isIdle() || Date.now() - startedAt >= IDLE_MAX_WAIT_MS) {
      callback();
      return;
    }
    setTimeout(check, IDLE_CHECK_MS);
  };
  check();
}
